<template>
  <div>
    <div class="title mb-3">MAPPA MOVIMENTO</div>
    <b-table :fields="fieldsToBeShown" :items="formattedRoundMap" sort-by="round" class="figbHeader">
      <template #cell(vs)="data">
        <span v-html="data.value"></span>
      </template>
    </b-table>
  </div>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
  name: 'MovementGuide',
  computed: {
    ...mapGetters({
      playerCurrentSessionMap: 'players/playerCurrentSessionMap',
      currentRound: 'tournament/currentRound',
      pairName: 'players/pairsList',
      sectors: 'tournament/sector'
    }),
    formattedRoundMap() {
      const that = this;
      return this.playerCurrentSessionMap.map(el => {
        const siglaGirone = that.sectors.Phases[el.phase].Series[el.serie].Sessions[el.session].Groups[el.sector].Sigla;
        return {
          position: siglaGirone + el.table + " " + ['N', 'E', 'S', 'W'][el.position],
          round: el.round,
          boards: el.Boards,
          vs: el.position % 2 === 0 ? that.pairName[el.EwEventId].Name : that.pairName[el.NsEventId].Name,
          _rowVariant: el.round === that.currentRound ? 'warning' : undefined
        }

      });
    },
    fieldsToBeShown() {
      return [
        {
          key: 'round',
          label: "Rnd"
        },
        {
          key: 'position',
          label: "Pos",
        }, {
          key: 'vs',
          label: "Vs",
          formatter: val => val.replace(" - ", "<br>")
        },
        {
          key: 'boards',
          label: "Bds",
          formatter: value => value.join(', ')
        }
      ];
    }
  }
};
</script>

<style scoped>

>>> .figbHeader thead {
  color: #3396B8;
  background-color: white;
}

.title {
  width: 100%;
  margin: 0 auto;
  text-align: center;
  color: #3396B8;
}
</style>
